"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)({
  root: {
    '& .MuiFormLabel-root': {
      display: 'inline-block',
      fontSize: '12px'
    }
  },
  horizontal: {
    '&.MuiFormGroup-root': {
      flexDirection: 'row'
    }
  }
}, {
  name: 'RadioButtonGroup'
});
exports.useStyles = useStyles;